module.exports = __webpack_public_path__ + "img/组3(1).88bf9d20.png";